import { useProtocolHostnamePort } from './oauthCallbacks';

export const getQRCodeUrl = (id: string): string => `${useProtocolHostnamePort()}/flowFestQr/${id}`;
export const getNFTNYCQRCodeUrl = (id: string): string => `${useProtocolHostnamePort()}/flowNFTNYCQR/${id}`;
